
import {profitForYear,profitForYearExport} from "@/api/http";

const columnList: Array<column> = [
    {
        prop: "project_name",
        label: "项目名称",
        width: 60,
    },
    {
        prop: "Jan",
        label: "一月",
        width: 70,
    },
    {
        prop: "Feb",
        label: "二月",
        width: 60,
    },
    {
        prop: "Mar",
        label: "三月",
        width: 75,
    },
    {
        prop: "Apr",
        label: "四月",
        width: 60,
    },
    {
        prop: "May",
        label: "五月",
        width: 75,
    },
    {
        prop: "Jun",
        label: "六月",
        width: 60,
    },
    {
        prop: "Jul",
        label: "七月",
        width: 60,
    },
    {
        prop: "Aug",
        label: "八月",
        width: 75,
    },
    {
        prop: "Sep",
        label: "九月",
        width: 60,
    },
    {
        prop: "Oct",
        label: "十月",
        width: 60,
    },
    {
        prop: "Nov",
        label: "十一月",
        width: 60,
    },
    {
        prop: "Dec",
        label: "十二月",
        width: 60,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted
} from "vue";
import {dateformat, getFirstNowLastDay} from "@/api/date" ;
import {Request} from '@/api/request';
import { column } from "@/assets/types/common";
import {useRoute, useRouter} from "vue-router";
export default defineComponent({
    name: "businessSummaryDetail",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['利润统计']);
        
        const headClass = inject("headClass");
        const Router = useRouter();
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as any),
            
            loading = ref(false),
            getFirstNowLastDay = ():number => {
                let now = new Date();
                let strLink = "-";
                let year = now.getFullYear();
                let month:any = now.getMonth() + 1;
                let day:any = now.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 1 && day <= 9) {
                    day = "0" + day;
                }
                let firstDate:string = year + strLink + month + strLink + day;
                let currentDate = year;
                console.log("currentDate==",currentDate);
                //var lastDay = this.getLastDay(year, month);
                //var lastDate = year + strLink + month + strLink + lastDay;
                return new Date(firstDate).getTime();
            },
            params = reactive({
                time: getFirstNowLastDay(),
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            screenChange = (e: string | Array < any > , key: any): void => {
                // let monthTime = Math.floor(new Date(params.time).getTime()/1000)
                // console.log(monthTime);
                getTableData();
            },
            exportChange = ()=>{
                let monthTime = Math.floor(new Date(params.time).getTime()/1000)
                let data = {
                    "status":2,
                    "monthTime":monthTime
                }
                loading.value = true;
                profitForYearExport(data).then((res:any)=>{
                    console.log(res);
                    loading.value = false;
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                    //tableData.value = res.content.list;
                });
            },
            getTableData = (): void => {
                //params.start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):0;
                //params.end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):0;
                let monthTime = Math.floor(new Date(params.time).getTime()/1000)
                let data = {
                    "status":2,
                    "monthTime":monthTime
                }
                loading.value = true;
                profitForYear(data).then((res:any)=>{
                    console.log(res);
                    loading.value = false;
                    tableData.value = res.content.list;
                });
                
            }
        onMounted(() => {
            getTableData();
        });
        return {
            columnList,
            headClass,
            exportChange,
            pageSize,
            currentPage,
            tableData,
            loading,
            handleSizeChange,
            handleCurrentChange,
            params,
            screenChange,
        };
    },
});
